import React, { useState, useEffect, useRef } from "react";
import "./SelectOptions.css";
import { TiArrowSortedDown } from "react-icons/ti";
import { TiArrowSortedUp } from "react-icons/ti";

export default function SelectOptions({ optionsData, onSelect }) {
  const dropdownOptionsRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleShowOptions = () => {
    setShowOptions(prevState => !prevState);
  };

  const changeSelectedOption = (item) => {
    setSelectedOption(item);
    onSelect(item);
    setShowOptions(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownOptionsRef.current &&
        !dropdownOptionsRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [dropdownOptionsRef]);

  useEffect(() => {
    if (optionsData.length > 0) {
      setSelectedOption(optionsData[0]);
      onSelect(optionsData[0]);
    }
  }, []);

  return (
    <div className="selectOptionsWrapper">
      <div className="selectedOption centeredFlex" onClick={handleShowOptions}>
        {showOptions ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
        {selectedOption && selectedOption.name}
      </div>
      {showOptions && (
        <div className="dropdownOptions scroll" ref={dropdownOptionsRef}>
          {optionsData.map((item) => (
            <div
              className="otherOption"
              key={item.id}
              onClick={() => changeSelectedOption(item)}
            >
              {item.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
